export const presets  = {
  blue: {
    toastBackgroundColour: "#7fbce9",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Montserrat',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  important: {
    toastBackgroundColour: "#e04747",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffff00",
    toastTextColourOpacity: 100,
    toastFont: 'Anton',
    toastFontSize: 18,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  contrast: {
    toastBackgroundColour: "#000000",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Lato',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  coffee: {
    toastBackgroundColour: "#4d4d4d",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#f2ca80",
    toastTextColourOpacity: 100,
    toastFont: 'Cairo',
    toastFontSize: 16,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  sky: {
    toastBackgroundColour: "#7fbce9",
    toastBackgroundColourOpacity: 20,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Montserrat',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  lime: {
    toastBackgroundColour: "#85e97f",
    toastBackgroundColourOpacity: 20,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Montserrat',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  beach: {
    toastBackgroundColour: "#f2ca80",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#4d4d4d",
    toastTextColourOpacity: 100,
    toastFont: 'Lobster',
    toastFontSize: 20,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  paper: {
    toastBackgroundColour: "#fbf6e8",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#864a40",
    toastTextColourOpacity: 100,
    toastFont: 'Dancing Script',
    toastFontSize: 18,
    toastFontWeight: 400,
    toastPremiumBackground: '',
  },
  kiwifruit: {
    toastBackgroundColour: "#7ee8fa",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Abel',
    toastFontSize: 16,
    toastFontWeight: 400,
    toastPremiumBackground: 'kiwifruit',
  },
  pastel: {
    toastBackgroundColour: "#ffcfdf",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Archivo Narrow',
    toastFontSize: 16,
    toastFontWeight: 400,
    toastPremiumBackground: 'pastel',
  },
  purple: {
    toastBackgroundColour: "#a4508b",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Montserrat',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: 'purple',
  },
  sunrise: {
    toastBackgroundColour: "#f7b42c",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Lato',
    toastFontSize: 16,
    toastFontWeight: 400,
    toastPremiumBackground: 'sunrise',
  },
  salmon: {
    toastBackgroundColour: "#f9c1b1",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Cairo',
    toastFontSize: 16,
    toastFontWeight: 400,
    toastPremiumBackground: 'salmon',
  },
  ocean: {
    toastBackgroundColour: "#63a4ff",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Montserrat',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: 'ocean',
  },
  yolk: {
    toastBackgroundColour: "#fbb034",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Cabin',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: 'yolk',
  },
  cloud: {
    toastBackgroundColour: "#ffffff",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#333333",
    toastTextColourOpacity: 100,
    toastFont: 'Lato',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: 'cloud',
  },
  jade: {
    toastBackgroundColour: "#08e1ae",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Cairo',
    toastFontSize: 16,
    toastFontWeight: 400,
    toastPremiumBackground: 'jade',
  },
  carbon: {
    toastBackgroundColour: "#485461",
    toastBackgroundColourOpacity: 100,
    toastTextColour: "#ffffff",
    toastTextColourOpacity: 100,
    toastFont: 'Montserrat',
    toastFontSize: 14,
    toastFontWeight: 400,
    toastPremiumBackground: 'carbon',
  },
}

export default {
    presets,
}
